import { theme } from "@src/theme";
import React from "react";

interface HomeSVGProps {
  $size: number;
  $active?: boolean;
}

const HomeSVG: React.FC<HomeSVGProps> = ({ $size, $active }) => (
  <svg
    style={{ paddingLeft: 0.5 }}
    width={$size}
    height={$size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 17.5V6.68588L9 0.614452L17.5 6.68588V17.5H12.0714V12.8571C12.0714 11.1603 10.6969 9.78571 9 9.78571C7.30314 9.78571 5.92857 11.1603 5.92857 12.8571V17.5H0.5Z"
      fill={$active ? theme.colors.yellow : "black"}
      stroke={$active ? theme.colors.yellow : theme.colors.black}
    />
  </svg>
);

export default HomeSVG;
